import { addMissingAlt } from './add-missing-alt'

if (document.querySelector('img')) {
  addMissingAlt()
}
